import { createTooltip } from "./tooltip-utils"

export default {
  mounted() {
    this._cleanup = createTooltip(this.el, (el) =>
      `<span class="font-semibold text-base-content">${el.dataset.salaryFull}</span><span class="text-base-content/60 ml-1.5">${el.dataset.capPct}</span>`,
      {
        className: "fixed z-40 bg-base-200 border border-base-300 rounded-lg shadow-xl px-3 py-2 text-sm pointer-events-none",
        whiteSpace: "nowrap",
        wordWrap: false,
        gap: 6
      }
    )
  },
  destroyed() {
    if (this._cleanup) this._cleanup()
  }
}
